import React from 'react';
import LessonHome from '../LessonHome';

const Lesson7 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson7;